export default {
  version: process.env.VUE_APP_VERSION || "v0.0.1",
};
